import { Container, Sprite } from "pixi.js"
import { PlayerId } from "$types"
import CharDisplay, { CharDisplayChar } from "./CharDisplay"
import { getTexture } from "./spritesheet"
import { TILE_SIZE, SCALE_FACTOR } from "./config"

export type PlayerStatus = "Active" | "Inactive" | "Dead"

export default class PlayerInfoDisplay extends Container {
  private _playerId: PlayerId
  get playerId() {
    return this._playerId
  }

  private _charDisplay: CharDisplay
  private _playerIcon: Sprite

  private _status: PlayerStatus
  get status() {
    return this._status
  }
  set status(value: PlayerStatus) {
    this._status = value
    this._playerIcon.texture = getTexture(`player${this._playerId}Status${value}`)
  }

  private _score = 0
  get score() {
    return this._score
  }
  set score(value: number) {
    if (value < 0) {
      this._score = 0
    } else if (value > 9) {
      this._score = 9
    } else {
      this._score = value
    }

    this._charDisplay.char = this._score.toString() as CharDisplayChar
  }


  constructor(params: { x: number, y: number, playerId: PlayerId, status: PlayerStatus }) {
    super({
      x: params.x,
      y: params.y,
    })

    this._playerId = params.playerId
    this._status = params.status
    this._playerIcon = new Sprite({
      texture: getTexture(`player${this._playerId}Status${this._status}`),
      x: 0,
      y: -2 * SCALE_FACTOR,
      width: TILE_SIZE * SCALE_FACTOR,
      height: TILE_SIZE * SCALE_FACTOR,
    })
    this.addChild(this._playerIcon)

    this._charDisplay = new CharDisplay({
      x: TILE_SIZE * SCALE_FACTOR + 1 * SCALE_FACTOR,
      y: 0,
      char: "0"
    })
    this.addChild(this._charDisplay)

  }
}
